<template>
  <div>403</div>
</template>

<script>
  export default {
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Code403.vue